import React, { createContext, useContext, useState } from "react";

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [dashboardData, setDashboardData] = useState({
    posStats: {
      totalSuppliers: 0,
      totalCategories: 0,
      activeProducts: 0,
      inactiveProducts: 0,
      productsPerSupplier: {},
    },
    lastFetched: null,
  });

  const [loading, setLoading] = useState(true);

  return (
    <DashboardContext.Provider
      value={{ dashboardData, setDashboardData, loading, setLoading }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);